import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import AddressFactory from "../../Entity/Factories/AddressFactory";

export default function* addressList(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, "addresses");

    const addresses = res.data.map(address => {
      return AddressFactory.create(address);
    });

    yield put({
      type: Constants.GLOBAL_ADDRESS_LIST_SUCCESS,
      payload: {
        addresses: addresses
      }
    });

  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchAddressList() {
  yield takeEvery(Constants.GLOBAL_ADDRESS_LIST, addressList);
}
